import { useEffect, useState } from 'react';
import { Link as RouterLink, useSearchParams } from 'react-router-dom';
import { Alert, Box, CircularProgress, Link, Stack, Typography } from '@mui/material';

import { idpApi } from '../../services/idp-api';

export function VerifyEmailPage() {
  const [searchParams] = useSearchParams();
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  useEffect(() => {
    const token = searchParams.get('token')?.trim() ?? '';

    if (token === '') {
      setErrorMessage('Verification token is missing. Please request a new verification email.');
      return;
    }

    window.location.replace(idpApi.verifyEmailUrl(token));
  }, [searchParams]);

  return (
    <Box sx={{ minHeight: '70vh', display: 'grid', placeItems: 'center' }}>
      <Stack spacing={2} alignItems="center" textAlign="center">
        {errorMessage !== null ? (
          <>
            <Alert severity="error">{errorMessage}</Alert>
            <Link component={RouterLink} to="/auth/signin" underline="hover">
              Return to sign in
            </Link>
          </>
        ) : (
          <>
            <CircularProgress />
            <Typography variant="body1">Verifying your email address...</Typography>
          </>
        )}
      </Stack>
    </Box>
  );
}
